import React, { createContext, Dispatch, JSX, ReactNode, SetStateAction, useContext, useState } from 'react';
import { logger } from '../util/Logger';
import { ProjectGroup, ProjectMember } from 'types';

interface Props {
  projectMembers?: ProjectMember[];
  projectGroups?: ProjectGroup[];
  children: ReactNode;
}

type ProjectContributorsContextType = {
  projectMembers: Props['projectMembers'];
  setProjectMembers: Dispatch<SetStateAction<Props['projectMembers']>>;

  projectGroups: Props['projectGroups'];
  setProjectGroups: Dispatch<SetStateAction<Props['projectGroups']>>;
};

const ProjectContributorsContext = createContext<ProjectContributorsContextType>({
  projectMembers: undefined,
  setProjectMembers: () => logger.warn('no Project provider'),

  projectGroups: undefined,
  setProjectGroups: () => logger.warn('no Project provider'),
});

export function useProjectContributorsContext(): ProjectContributorsContextType {
  return useContext(ProjectContributorsContext);
}

export function ProjectContributorsProvider({ children }: Props): JSX.Element {
  const [projectMembers, setProjectMembers] = useState<Props['projectMembers']>(undefined);
  const [projectGroups, setProjectGroups] = useState<Props['projectGroups']>(undefined);

  return (
    <ProjectContributorsContext.Provider value={{ projectMembers, setProjectMembers, projectGroups, setProjectGroups }}>
      {children}
    </ProjectContributorsContext.Provider>
  );
}
